export default __webpack_public_path__ + "145c92c16d79a6d9379bf328e2c52a1d.svg";